<template>
  <div
    class="grid-x grid-margin-x"
    :class="spacingClasses"
  >
    <div
      v-if="isMobile"
      class="cell title-mobile"
      :class="isSpacingExperimentEnabled ? 'padding-bottom-xs' : 'padding-bottom-s'"
    >
      <ProductTitle />
      <ReviewRating v-if="!isGiftWithPurchase" />
    </div>
    <div class="cell medium-6 large-6 xlarge-7">
      <Media />
    </div>
    <div class="cell medium-6 large-5 large-offset-1 xlarge-5 xlarge-offset-0">
      <div
        v-if="!isMobile"
        class="title"
      >
        <ProductTitle />
        <ReviewRating
          v-if="!isGiftWithPurchase"
          class="margin-bottom-m"
        />
      </div>
      <div
        v-if="newMarkdown"
        class="small medium-margin-bottom-m small-margin-top-m"
      >
        {{ newMarkdown }}
      </div>
      <OffersAvailable
        v-if="isBcom && !isMobile"
      />
      <ColorSwatches
        v-if="!isGiftWithPurchase && isMcom && isMultiColor"
        :id="productId"
        :color-label="`COLORS IN THIS COLLECTION`"
        :color-props="colorProps"
        class="margin-bottom-m small-margin-top-m medium-margin-top-z"
      />
      <ShopMembersButton
        :class="{
          'margin-top-m': isGiftWithPurchase,
          'small-margin-top-m medium-margin-top-z': !isGiftWithPurchase && (isBcom || !isMultiColor),
        }"
      />
      <ShippingAndReturnsBadgeFacade
        v-if="killswitches.isShippingAndReturnsBadgeEnabled"
        class="margin-bottom-m"
      />
      <LoyalList
        v-if="isLoyalList"
        class="margin-top-xs margin-bottom-m"
      />
      <ProsZoneAVertical
        v-if="!isMobile"
        data-testid="pros-section"
        class="margin-top-m"
      />
    </div>
    <div
      class="cell large-12"
      data-testid="product-details-section"
    >
      <ProductDetailsFacade
        :class="{
          'margin-top-xl': !isMobile,
          'margin-top-m': isMobile,
        }"
      />
    </div>
  </div>

  <div id="members-of-master">
    <LatchKey v-if="isLatchKey" />

    <template v-else>
      <h2
        class="h3"
        :class="shoppableRedesignOptimization ? 'margin-bottom-s' : 'margin-bottom-m'"
      >
        Choose Your Items ({{ memberProductIds.length }})
      </h2>
      <ListOfMemberProducts :list="memberProductIds" />
    </template>
  </div>
</template>

<script setup>
import { ShippingAndReturnsBadgeFacade } from '@modules/shippingAndRetunsBadge';
import useMembersOfProduct from '@composables/useMembersOfProduct';
import ProductTitle from '@components/ProductCard/ProductTitle.common';
import ListOfMemberProducts from '@components/ProductCard/ListOfMemberProducts';
import OffersAvailable from '@components/ProductCard/OffersAvailable';
import { ProductDetailsFacade } from '@modules/productDetails';
import ReviewRating from '@components/ReviewRating';
import Media from '@components/common/Media/Media';
import LatchKey from '@components/LatchKey';
import ShopMembersButton from '@components/ShopMembersButton';
import ColorSwatches from '@components/ColorSwatches';
import LoyalList from '@components/LoyalList.bcom';
import ProsZoneAVertical from '@components/pros/ProsZoneAVertical';
import { useColor } from '@modules/color/composables';

import { useDeviceType } from '@composables/utils/useDeviceType';
import { useProductType } from '@composables/useProductType';
import { useProduct } from '@modules/product';
import { useFeatureEligibility, useKillswitches } from '@modules/featureControl';
import { useBrand } from '@composables/useBrand';
import { useNewMarkdownMaster } from '@composables/useNewMarkdownMaster';
import { useExperiments } from '@composables/useExperiments';

const { killswitches } = useKillswitches();
const { isMobile } = useDeviceType();
const { isLatchKey, isGiftWithPurchase } = useProductType();
const { isMcom, isBcom } = useBrand();
const {
  isLoyalList, isMultiColor, shoppableRedesignOptimization,
} = useFeatureEligibility();
const { memberProductIds } = useMembersOfProduct();
const { productId } = useProduct();

const { colorProps } = useColor();
const { newMarkdown } = useNewMarkdownMaster();
const spacingClasses = shoppableRedesignOptimization ? 'small-margin-bottom-m large-margin-bottom-xl' : 'margin-bottom-xxl';
const {
  experimentFlags: { isSpacingExperimentEnabled },
} = useExperiments();
</script>

<style lang="scss" scoped>
@import '~settingSCSS';
@include title;
</style>
